export default __webpack_public_path__ + "static/media/person.9c538270.png";